class BlogFiltersDrag {
  constructor() {
    this.filtersContainer = document.querySelector('.blog__filters');
    this.filtersList = document.querySelector('.blog__filters-items');
    this.scrollContainer = document.querySelector('.blog__head');
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.isInitialized = false;
    this.dragThreshold = 5; // Minimum distance to start dragging
    this.hasMoved = false;
    
    this.init();
  }

  init() {
    if (!this.filtersContainer || !this.filtersList || !this.scrollContainer) {
      return;
    }
    
    // Always scroll to active filter on page load (works on both desktop and mobile)
    this.scrollToActiveFilter();
    
    // Only enable drag on desktop (min-width: 750px)
    if (window.innerWidth < 750) {
      return;
    }
    
    if (this.isInitialized) {
      return;
    }
    
    this.addEventListeners();
    this.isInitialized = true;
  }

  addEventListeners() {
    // Mouse events
    this.filtersList.addEventListener('mousedown', this.startDragging.bind(this));
    document.addEventListener('mousemove', this.drag.bind(this));
    document.addEventListener('mouseup', this.stopDragging.bind(this));
    
    // Prevent default drag behavior on links
    this.filtersList.addEventListener('dragstart', (e) => e.preventDefault());
    
    // Prevent text selection while dragging
    this.filtersList.addEventListener('selectstart', (e) => {
      if (this.isDragging) e.preventDefault();
    });
    

  }

  startDragging(e) {
    this.startX = e.clientX;
    this.scrollLeft = this.scrollContainer.scrollLeft;
    this.hasMoved = false;
    
    // Prevent default to avoid text selection
    e.preventDefault();
  }

  drag(e) {
    if (!this.startX) return;
    
    const x = e.clientX;
    const distance = Math.abs(x - this.startX);
    
    // Only start dragging if we've moved beyond the threshold
    if (!this.isDragging && distance > this.dragThreshold) {

      this.isDragging = true;
      this.scrollContainer.style.cursor = 'grabbing';
      this.filtersList.style.cursor = 'grabbing';
      this.filtersList.style.userSelect = 'none';
    }
    
    if (this.isDragging) {
      e.preventDefault();
      const walk = (x - this.startX) * 1.5; // Reduced scroll speed multiplier
      this.scrollContainer.scrollLeft = this.scrollLeft - walk;
    }
  }

  stopDragging() {
    if (this.isDragging) {

    }
    
    this.isDragging = false;
    this.startX = 0;
    this.scrollContainer.style.cursor = 'grab';
    this.filtersList.style.cursor = 'grab';
    this.filtersList.style.userSelect = '';
  }

  scrollToActiveFilter() {
    // Add a small delay to ensure DOM is fully rendered
    setTimeout(() => {
      const activeFilter = this.filtersList.querySelector('.blog__filters-item.is-active');
      
      if (!activeFilter || !this.scrollContainer) {
        return;
      }
      
      // Get the position of the active filter relative to the scroll container
      const containerRect = this.scrollContainer.getBoundingClientRect();
      const activeFilterRect = activeFilter.getBoundingClientRect();
      
      // Calculate the position to scroll to
      const scrollLeft = this.scrollContainer.scrollLeft;
      const activeFilterLeft = activeFilterRect.left - containerRect.left + scrollLeft;
      const containerWidth = containerRect.width;
      
      // Calculate the center position of the active filter
      const activeFilterCenter = activeFilterLeft + (activeFilterRect.width / 2);
      const targetScrollLeft = activeFilterCenter - (containerWidth / 2);
      
      // Ensure we don't scroll beyond the container bounds
      const maxScrollLeft = this.scrollContainer.scrollWidth - containerWidth;
      const finalScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
      
      // Smooth scroll to the active filter with fallback for older browsers
      if (this.scrollContainer.scrollTo) {
        this.scrollContainer.scrollTo({
          left: finalScrollLeft,
          behavior: 'smooth'
        });
      } else {
        // Fallback for browsers that don't support scrollTo with options
        this.scrollContainer.scrollLeft = finalScrollLeft;
      }
    }, 100);
  }

  destroy() {
    if (this.filtersList) {
      this.filtersList.removeEventListener('mousedown', this.startDragging.bind(this));
      document.removeEventListener('mousemove', this.drag.bind(this));
      document.removeEventListener('mouseup', this.stopDragging.bind(this));
    }
    this.isInitialized = false;
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  if (!window.blogFiltersDrag) {
    window.blogFiltersDrag = new BlogFiltersDrag();
  }
});

// Also try to initialize after a short delay in case DOM isn't ready
setTimeout(() => {
  if (!window.blogFiltersDrag) {
    window.blogFiltersDrag = new BlogFiltersDrag();
  }
}, 500);

// Re-initialize on window resize to handle responsive behavior
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  
  // Small delay to ensure resize is complete
  resizeTimeout = setTimeout(() => {
    // Only reinitialize if we're crossing the 750px threshold
    const wasDesktop = window.innerWidth >= 750;
    const isDesktop = window.innerWidth >= 750;
    
    if (wasDesktop !== isDesktop) {
      // Remove existing instance
      if (window.blogFiltersDrag) {
        delete window.blogFiltersDrag;
      }
      
      // Create new instance
      window.blogFiltersDrag = new BlogFiltersDrag();
    }
  }, 150);
});
